import { createTheme, type Theme } from '@mui/material/styles'

import { charts } from './charts'
import * as components from './components'
import { palette } from './palette'
import { shape } from './shape'
import { states } from './states'
import { typography } from './typography'

const theme: Theme = createTheme({
  components,
  palette,
  shape,
  typography,
  states,
  charts,
})

export default theme
